import React, { useEffect, useState } from 'react';
import { config } from "~/config"
import { useAuth } from '~src/hooks/useAuth';
import { Alert } from '~src/components/common';
import { Button } from '~src/components/Button';
import Link from '~src/components/Link';
import { useRouter } from 'next/router';

export default function PurchaseNodePrompt() {
  const {status, fetcher} = useAuth();
  const {pathname} = useRouter();
  const [nodeInfo, setNodeInfo] = useState(null);

  useEffect(() => {
    const loadNodeInfo = async () => {
      try {
        const nodeData = await fetcher({
          method: 'GET',
          url: `${config.backend.giveUrl}/nodes/info`,
        });

        setNodeInfo(nodeData);
      }
      catch(e) {
        console.error("Failed to load node info for PurchaseNodePrompt: ", e);
      }
    }

    if (status === "signedIn") {
      loadNodeInfo();
    }
  }, [status, fetcher]);

  if (pathname.includes("dashboard/blockchain")) {
    return null;
  }

  if (nodeInfo?.licenses?.length === 0) {
    return (
      <Alert type="warning">
        <h3><Link href={"/dashboard/blockchain"} className="underline font-semibold">Purchase a node</Link> to be eligible to earn rewards!</h3>
      </Alert>
    )
  }
  return (
    <div key="no-purchase-prompt" id="no-purchase-prompt" className="hidden"></div>
  )
}